<template>
  <div v-if="totalSlides > 1" class="flex justify-center mt-6 space-x-2">
    <button
      v-for="(slide, index) in totalSlides"
      :key="`dot-${index}`"
      @click="goToSlide(index)"
      class="h-2 rounded-full transition-all duration-300"
      :class="
        currentSlide % totalSlides === index
          ? 'w-8 bg-gray-900 dark:bg-white'
          : 'w-2 bg-gray-400 dark:bg-white/40 hover:bg-gray-600 dark:hover:bg-white/60'
      "
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  totalSlides: number;
  currentSlide: number;
}

interface Emits {
  (e: 'go-to-slide', index: number): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const goToSlide = (index: number) => {
  emit('go-to-slide', index);
};
</script>
